import React from "react";

export function ProductCategoryColumn(cellContent, row) {
    return (
        <>
                <span className=" text-hover-primary mb-1 font-size-lg">
                    {row.productCategory[0].name}
                </span>
        </>
    );
}

